import { Airbnb, Expedia, Scentbird, Picto, Easybank, Portfolio } from '../../assets'

export const projects = [
    {
        id: 1,
        name: 'Promotional Email',
        alt: 'laptop with promotional html email template displayed on screen',
        image: Expedia,
        desc: 'Recreated Expedia Promotional HTML Email.',
        tools: ["HTML", "CSS"],
        filter: "emails",
        url: 'https://expedia-ma.netlify.app/',
        git: 'https://github.com/abuiko/htmlemail-prac-3-/blob/main/index.html',
    },
    {
        id: 2,
        name: 'Transactional Email',
        alt: 'laptop with transactional email template displayed on screen',
        image: Airbnb,
        desc: 'Recreated Airbnb Transactional HTML Email.',
        tools: ["HTML", "CSS"],
        filter: "emails",
        url: 'https://airbnb-ma.netlify.app/',
        git: 'https://github.com/abuiko/htmlemail-prac-4/blob/main/index.html',
    },
    {
        id: 3,
        name: 'Newsletter',
        alt: 'laptop with newsletter email template displayed on screen',
        image: Scentbird,
        desc: 'Recreated OneMedical NewsLetter Email.',
        tools: ["HTML", "CSS"],
        filter: "emails",
        url: 'https://onemed-ma.netlify.app/',
        git: 'https://github.com/abuiko/htmlemail-prac-5/blob/main/index.html',
    },

    {
        id: 4,
        name: 'Picto',
        alt: 'laptop with photography website displayed on screen',
        image: Picto,
        desc: 'Website where users can search for free photos to download.',
        tools: ["HTML | CSS | Javascript", "Unsplash API"],
        filter: "websites",
        url: 'https://picto-ma.netlify.app/',
        git: 'https://github.com/abuiko/picto',
    },


    {
        id: 5,
        name: 'Easybank',
        alt: 'laptop with the screenshot of the banking website displayed on screen',
        image: Easybank,
        desc: 'Landing page created as part of the challenge from frontendmentor.io',
        tools: ["HTML | CSS | Javascript", "SASS"],
        filter: "websites",
        url: 'https://easybank-ma.netlify.app/',
        git: 'https://github.com/abuiko/web_challenge',
    },
    {
        id: 6,
        name: 'Portfolio',
        alt: 'laptop with the screenshot of the portfolio website displayed on screen',
        image: Portfolio,
        desc: 'Fully responsive front end / html email developer portfolio website',
        tools: ["React", "Styled Components"],
        filter: "websites",
        url: 'https://alenabuiko.netlify.app/',
        git: 'https://github.com/abuiko/portfolio_2.0',
    }
] 